import { Outlet, Navigate } from 'react-router-dom'

const PrivateRoutes = () => {
    const user = sessionStorage.getItem('accessToken');
    const BreefAccesstoken = sessionStorage.getItem('BreefAccesstoken');
    return(
        user || BreefAccesstoken ? <Outlet/> : <Navigate to="/no-access"/>
    )
}

export default PrivateRoutes